import * as React from "react";
import styles from "../styles/pages/pricing.module.scss";
import MetaHeader from "../components/meta-header/meta-header";
import { HeaderNewComponent } from "../new-components/header/Header";
import FooterNewComponent from "../new-components/footer/Footer";
import KeysNewComponent from "../new-components/home/Keys/Keys";
import { useTranslation } from "next-i18next";
import nextI18NextConfig from "../next-i18next.config.js";
import { trackPage } from "../api/analytics";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

function PricingScreen(props) {
  const { i18n, t } = useTranslation("pricing");

  React.useEffect(() => {
    trackPage("Pricing", {
      store: props.store,
      lang: props.lang,
      language: props.language,
      i18N: i18n.language,
    });
  }, [i18n.language, props.lang, props.language, props.store]);

  function getDescription() {
    return "Choose pricing plans";
  }

  function getTitle() {
    return "Pricing | Choose";
  }

  return (
    <div className={styles.pricing}>
      <MetaHeader description={getDescription()} title={getTitle()} />
      <HeaderNewComponent
        disableScroll={true}
        store={props.store}
        language={i18n.language}
      />

      <div className="container">
        <div className={styles.header}>
          <h1>{t("header_title")}</h1>
          <p>{t("header_subtitle")}</p>
        </div>

        <div className={styles.plansContainer}>
          <div className={`${styles.planCard} ${styles.freePlan}`}>
            <div className={styles.planHeader}>
              <h3>Free</h3>
              <div className={styles.price}>
                <span className={styles.currency}>{t("currency")}</span>
                <span className={styles.amount}>0</span>
                <span className={styles.period}>/month</span>
              </div>
            </div>

            <div className={styles.planFeatures}>
              <ul>
                <li>
                  <img
                    src="https://public.choose.app/website/new/images/Check.svg"
                    alt="check"
                  />
                  {t("free_feature_1")}
                </li>
                <li>
                  <img
                    src="https://public.choose.app/website/new/images/Check.svg"
                    alt="check"
                  />
                  {t("free_feature_2")}
                </li>
                <li>
                  <img
                    src="https://public.choose.app/website/new/images/Check.svg"
                    alt="check"
                  />
                  {t("free_feature_3")}
                </li>
                <li>
                  <img
                    src="https://public.choose.app/website/new/images/Check.svg"
                    alt="check"
                  />
                  {t("free_feature_4")}
                </li>
              </ul>
            </div>

            <button className={styles.planButton}>
              {t("get_started_button")}
            </button>
          </div>

          <div className={`${styles.planCard} ${styles.customPlan}`}>
            <div className={styles.badge}>Popular</div>
            <div className={styles.planHeader}>
              <h3>{t("custom_plan_title")}</h3>
              <div className={styles.price}>
                <span className={styles.customPrice}>
                  {t("custom_pricing")}
                </span>
              </div>
            </div>

            <div className={styles.planFeatures}>
              <ul>
                <li>
                  <img
                    src="https://public.choose.app/website/new/images/Check.svg"
                    alt="check"
                  />
                  {t("custom_feature_1")}
                </li>
                <li>
                  <img
                    src="https://public.choose.app/website/new/images/Check.svg"
                    alt="check"
                  />
                  {t("custom_feature_2")}
                </li>
                <li>
                  <img
                    src="https://public.choose.app/website/new/images/Check.svg"
                    alt="check"
                  />
                  {t("custom_feature_3")}
                </li>
                <li>
                  <img
                    src="https://public.choose.app/website/new/images/Check.svg"
                    alt="check"
                  />
                  {t("custom_feature_4")}
                </li>
                <li>
                  <img
                    src="https://public.choose.app/website/new/images/Check.svg"
                    alt="check"
                  />
                  {t("custom_feature_5")}
                </li>
                <li>
                  <img
                    src="https://public.choose.app/website/new/images/Check.svg"
                    alt="check"
                  />
                  {t("custom_feature_6")}
                </li>
              </ul>
            </div>

            <button className={`${styles.planButton} ${styles.primary}`}>
              {t("contact_sales_button")}
            </button>
          </div>
        </div>

        <hr className={styles.hr} />
      </div>

      <KeysNewComponent />
      <FooterNewComponent store={props.store} />
    </div>
  );
}

export const getServerSideProps = async (props) => {
  return {
    props: {
      ...(await serverSideTranslations(
        props.query.language ||
          props.query.lang ||
          props.locale ||
          props.defaultLocale ||
          "fr",
        ["common", "keys", "pricing"],
        nextI18NextConfig as any
      )),
      ...props.query,
      store: props.query.store || "fr",
    },
  };
};

export default PricingScreen;
